import '@fontsource/noto-sans'
import '@fontsource/zen-old-mincho'
import 'leaflet/dist/leaflet.css'

import {
  detectBrowserLocale,
  getHomePath,
  getPreferredLocale,
} from './src/services/language'

export const onInitialClientRender = () => {
  if (typeof window === 'undefined') return

  const { pathname } = window.location

  if (pathname !== '/' && pathname !== '') return

  const preferred = getPreferredLocale()
  const locale = preferred ?? detectBrowserLocale()
  const target = getHomePath(locale)

  if (target !== '/') {
    window.location.replace(target)
  }
}
